import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/product_subitem',
    name: 'PUT_PRODUCT_SUBITEM',
    method: 'PUT',
  });

  return [exec, isRequestSuccessed];
});
